import React, { useEffect, useState } from "react";
import axios from 'axios';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { toast } from 'react-toastify';
//import logoBig from '../../../assets/img/logoBig.jpg';
import { BalanceChart } from "../../Helpers";
let logoBig = "default.jpg";

function Settings() {
  const [errors, setErrors] = useState(false);
  const [userData, setUserData] = useState(false);
  const [kycData, setKycData] = useState(false);
  const [uploadData, setUploadData] = useState(false);
  const [indiaState, setIndiaState] = useState(false);
  const [indiaDistrict, setIndiaDistrict] = useState(false);
  const [nepalState, setNepalState] = useState(false);
  const [nepalDistrict, setNepalDistrict] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        const response = await axios.post("/update/profile", { "userid": userData?._id, ...jsonData });
        const { message } = response.data;
        toast(message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        jsonData[item.name] = item.value;
      }
    });
    if (jsonData.new_password != jsonData.confirm_new_password) {
      toast("New password and confirm new password has not matched!");
    }
    else {
      try {
        const response = await axios.post("/user/change/password", jsonData);
        const { message } = response.data;
        toast(message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  
  const getData = async () => {
    try {
      const response = await axios.post('/user/loggedinuser');
      const { status, user, kyc } = response.data;
      if (status) {
        if (user.indiaAddress.state != "") {
          let e = { target: { name: "indian_state", value: user.indiaAddress.state } };
          changeData(e);
        }
        if (user.nepalAddress.state != "") {
          let e = { target: { name: "nepal_state", value: user.nepalAddress.state } };
          changeData(e);
        }
        setUserData(user);
        setKycData(kyc);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getIndiaState = async () => {
    try {
      const response = await axios.post('/v2/remittance/get/states', { country: "India" });
      const { status, data } = response.data;
      if (status) {
        setIndiaState(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getNepalState = async () => {
    try {
      const response = await axios.post('/v2/remittance/get/states', { country: "Nepal" });
      const { status, data } = response.data;
      if (status) {
        setNepalState(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
    getIndiaState();
    getNepalState();
  }, []);
  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }
  const changeData = async (e) => {
    try {
      if (e.target.name == "indian_state") {
        setUserData({ ...userData, indiaAddress: { state: e.target.value } });
        const response = await axios.post('/v2/remittance/get/district', { state: e.target.value });
        const { status } = response.data;
        if (status) {
          setIndiaDistrict(response.data.data);
        }
      }
      else if (e.target.name == "nepal_state") {
        setUserData({ ...userData, nepalAddress: { state: e.target.value } });
        const response = await axios.post('/v2/remittance/get/district', { state: e.target.value });
        const { status } = response.data;
        if (status) {
          setNepalDistrict(response.data.data);
        }
      }
      else {
        setUserData({ ...userData, [e.target.name]: e.target.value });
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  return (
    <div class="content-wrapper">
      <BalanceChart />
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Profile</h4>
              <Tabs
                defaultActiveKey="personal"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="personal" title="Personal info">
                  <form class="form-sample" onSubmit={handleSubmit}>
                    <p class="card-description">
                      Personal info
                    </p>
                    <div class="row">
                      <div class="col-md-4">
                        <label>User Name</label>
                        <div>
                          <input type="text" class="form-control" name="name" value={userData?.name} onChange={changeData} />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>Email Address</label>
                        <div>
                          <input type="text" class="form-control" name="email" value={userData?.email} onChange={changeData} />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>Phone Number</label>
                        <div>
                          <input type="text" class="form-control" name="mobile" value={userData?.mobile} onChange={changeData} />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>Address</label>
                        <div>
                          <input type="text" class="form-control" name="address" value={userData?.address} onChange={changeData} />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>City</label>
                        <div>
                          <input type="text" class="form-control" name="city" value={userData?.city} onChange={changeData} />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>State</label>
                        <div>
                          <input type="text" class="form-control" name="state" value={userData?.state} onChange={changeData} />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>Country</label>
                        <div>
                          <input type="text" class="form-control" name="country" value={userData?.country} onChange={changeData} />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div>
                          <input type="submit" class="btn btn-primary" value="Update" />
                        </div>
                      </div>
                    </div>
                  </form>
                </Tab>
                <Tab eventKey="changePassword" title="Change Password">
                  <form class="form-sample" onSubmit={handleChangePasswordSubmit}>
                    <p class="card-description">
                      Change Password
                    </p>
                    <div class="row">
                      <div class="col-md-4">
                        <label>Old Password</label>
                        <div>
                          <input type="password" class="form-control" name="old_password" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>New Password</label>
                        <div>
                          <input type="password" class="form-control" name="new_password" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>Confirm New Password</label>
                        <div>
                          <input type="password" class="form-control" name="confirm_new_password" />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div>
                          <input type="submit" class="btn btn-primary" value="Update" />
                        </div>
                      </div>
                    </div>
                  </form>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
